export default __webpack_public_path__ + "static/media/In_person.bd1a1ab0.jpg";